export const LOTTERY_GAMES = {
  megasena: { label: 'Mega-Sena', pick: 6, max: 60 },
  lotofacil: { label: 'Lotofácil', pick: 15, max: 25 },
  quina: { label: 'Quina', pick: 5, max: 80 },
  lotomania: { label: 'Lotomania', pick: 50, max: 100 },
}

export const generateLotteryNumbers = (gameKey) => {
  const { pick, max } = LOTTERY_GAMES[gameKey]
  const pool = Array.from({ length: max }, (_, i) => i + 1)
  const numbers = []
  for (let i = 0; i < pick; i++) {
    const index = Math.floor(Math.random() * pool.length)
    numbers.push(pool[index])
    pool.splice(index, 1)
  }
  return numbers.sort((a, b) => a - b)
}
